import { all } from "redux-saga/effects";
import adminAuthSaga from "./adminAuth/adminAuthSaga";
import jobSeekerSaga from "./jobSeeker/jobSeekerSaga";
import companyListSaga from "./companyList/companyListSaga";
import messageTemplateSaga from "./messageTemplate/messageTemplateSaga";
import employerTemplateSaga from "./employerTemplate/employerTemplateSaga";
import jobPostListSaga from "./jobPostList/jobPostListSaga";

import logSaga from "./log/logSaga";
import commonSaga from "./common/commonSaga";

export default function* rootSaga() {
  yield all([adminAuthSaga(), jobSeekerSaga(), companyListSaga(), messageTemplateSaga(), employerTemplateSaga(), jobPostListSaga(), logSaga(), commonSaga()]);
}
